import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";
import { ILeagueSchedule } from "../../types/api";

import "../../assets/css/majorybl/pages/leagues.scss";
import { getLeagueSchedule } from "../../lib/api";
import Schedule from "../../components/Schedule";
import { store } from "../..";
import {
    leagueManagementActions,
    selectSelectedLeague,
} from "../../features/leaguemgmt/leagueManagementSlice";

export const loader = async ({ params }: any) => {
    let { leagueId } = params;
    leagueId = parseInt(leagueId);

    let leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    const [{ schedule }] = await Promise.all([
        getLeagueSchedule(leagueId),
        leaguesPromise,
    ]);

    store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
    const league = selectSelectedLeague(store.getState());

    const header = league
        ? `${league.ageLevel}${
              league.designation ? ` ${league.designation}` : ""
          }${league.direction ? ` ${league.direction}` : ""} Schedule`
        : "League Schedule";

    return {
        schedule,
        header,
    };
};

const LeagueSchedule = (): React.JSX.Element => {
    const { schedule } = useLoaderData() as { schedule: ILeagueSchedule };

    return (
        <div data-testid="leagueScheduleContent">
            <Container fluid="xs">
                <Row>
                    <Col>
                        {schedule?.games ? (
                            <Schedule
                                schedule={schedule?.games.filter(g =>
                                    ["Scheduled", "Rescheduled"].includes(
                                        g.status,
                                    ),
                                )}
                                scheduleType="league"
                            />
                        ) : (
                            <h2>No scheduled games</h2>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LeagueSchedule;
